export const collectionsPage = {
    'collections.page.title': 'Collections',
    'collections.page.bonus.toy.description':
        'To obtain this special toy, you’ll need to complete the entire collection by collecting every other toy in the series. Once you have gathered each item in the set, this exclusive toy will become available as a reward, symbolizing your accomplishment in completing the full collection.',
    'collections.page.trending.collections.title': 'Trending Collections',
}
